/**
 * Sidebar component - Modern design matching app UI/UX
 */

import {Link, useLocation} from 'react-router-dom';
import {useUIStore} from '@voxapilot/shared';
import {ROUTES} from '../../config/constants';
import {cn} from '../../utils/cn';

const navigation = [
  {name: 'Dashboard', href: ROUTES.APP, icon: '📊'},
  {name: 'Meetings', href: ROUTES.APP_MEETINGS, icon: '📅'},
  {name: 'Profile', href: ROUTES.APP_PROFILE, icon: '👤'},
  {name: 'Settings', href: ROUTES.APP_SETTINGS, icon: '⚙️'},
];

export function Sidebar() {
  const location = useLocation();
  const {sidebarOpen, sidebarCollapsed} = useUIStore();

  if (!sidebarOpen) {
    return null;
  }

  return (
    <aside
      className={cn(
        'bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700',
        'transition-all duration-300 ease-in-out',
        'shadow-sm',
        sidebarCollapsed ? 'w-20' : 'w-64'
      )}
    >
      <nav className="p-4 space-y-1">
        {navigation.map((item) => {
          // Check if current route matches (handle both /app and legacy routes)
          const isActive = 
            location.pathname === item.href ||
            (item.href === ROUTES.APP && location.pathname === ROUTES.APP) ||
            (item.href === ROUTES.APP_MEETINGS && location.pathname.startsWith(ROUTES.APP_MEETINGS)) ||
            (item.href === ROUTES.APP_PROFILE && location.pathname === ROUTES.APP_PROFILE) ||
            (item.href === ROUTES.APP_SETTINGS && location.pathname === ROUTES.APP_SETTINGS);
          
          return (
            <Link
              key={item.name}
              to={item.href}
              className={cn(
                'flex items-center gap-3 px-4 py-3 rounded-lg',
                'text-sm font-medium',
                'transition-all duration-200',
                'group',
                isActive
                  ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 shadow-sm'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/50 hover:text-gray-900 dark:hover:text-white'
              )}
            >
              <span className={cn(
                'text-xl transition-transform duration-200',
                isActive && 'scale-110',
                !isActive && 'group-hover:scale-105'
              )}>
                {item.icon}
              </span>
              {!sidebarCollapsed && (
                <span className={cn(
                  'transition-opacity duration-200',
                  isActive ? 'opacity-100' : 'opacity-90 group-hover:opacity-100'
                )}>
                  {item.name}
                </span>
              )}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}

